import { AlertTriangle } from 'lucide-react'
import { downSources, useApiHealthStore } from '@/core/transport/health'
import { Alert, AlertDescription } from '../shadcn/alert'

const LABELS = { bcb: 'BCB', boc: 'Bank of Canada' } as const

export function ApiHealthBanner() {
  const failures = useApiHealthStore((s) => s.failures)
  const down = downSources(failures)

  if (down.length === 0) return null

  return (
    <div className="container py-2">
      <Alert variant="warning">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>
          {down.length === 1
            ? `${LABELS[down[0] as 'bcb' | 'boc']} com instabilidade — recálculos podem falhar enquanto a fonte não responde.`
            : 'BCB e Bank of Canada com instabilidade — recálculos podem falhar enquanto as fontes não respondem.'}
        </AlertDescription>
      </Alert>
    </div>
  )
}
